'use client';

import { c as _c } from "react/compiler-runtime";
import { Bar, BarChart, CartesianGrid, Cell, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { TimeMetricsChartProps } from '../../types/lote.types';
export function TimeMetricsChart(t0) {
  const $ = _c(21);
  const {
    data
  } = t0;
  const hasData = data.some(_temp);
  if (!hasData) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex h-full items-center justify-center"><p className="text-body font-body text-subtext-color">Sem dados de tempo disponíveis</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: 5,
      right: 10,
      left: -10,
      bottom: 0
    };
    t2 = <CartesianGrid strokeDasharray="3 3" stroke="rgb(229, 229, 229)" />;
    t3 = <XAxis dataKey="temperature" fontSize={12} stroke="rgb(115, 115, 115)" tickLine={false} />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <YAxis fontSize={11} stroke="rgb(115, 115, 115)" tickLine={false} allowDecimals={false} label={{
      value: "Dias",
      angle: -90,
      position: "insideLeft",
      style: {
        fontSize: "11px",
        fill: "rgb(115, 115, 115)"
      }
    }} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Tooltip contentStyle={{
      backgroundColor: "rgb(255, 255, 255)",
      border: "1px solid rgb(229, 229, 229)",
      borderRadius: "8px",
      fontSize: "13px"
    }} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Legend wrapperStyle={{
      fontSize: "12px",
      paddingTop: "8px"
    }} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [4, 4, 0, 0];
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== data) {
    t8 = data.map(_temp2);
    $[8] = data;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <Bar dataKey="diasMedios" name="Dias em Aberto" radius={t7} maxBarSize={40}>{t8}</Bar>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [4, 4, 0, 0];
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== data) {
    t11 = data.map(_temp3);
    $[13] = data;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11) {
    t12 = <Bar dataKey="tempoResposta" name="Tempo de Resposta" radius={t10} maxBarSize={40}>{t11}</Bar>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== data || $[18] !== t12 || $[19] !== t9) {
    t13 = <ResponsiveContainer width="100%" height="100%"><BarChart data={data} margin={t1}>{t2}{t3}{t4}{t5}{t6}{t9}{t12}</BarChart></ResponsiveContainer>;
    $[17] = data;
    $[18] = t12;
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
}
function _temp3(entry_0, index_0) {
  return <Cell key={`cell-resp-${index_0}`} fill={entry_0.color} opacity={0.5} />;
}
function _temp2(entry, index) {
  return <Cell key={`cell-dias-${index}`} fill={entry.color} opacity={0.85} />;
}
function _temp(d) {
  return d.diasMedios > 0 || d.tempoResposta > 0;
}